import { BeanPrimaryEntity } from "../../bean-primary-entity";
import { MiningEquipmentNotes } from "./mining-equipment-notes";

export class MiningEquipment extends BeanPrimaryEntity {
    miningEquipmentId: number;
    miningEquipmentName: string;
    unitId: number;
    startUpDate: Date | null;
    startUpResolution: number | null;
    shutDownDate: Date | null;
    shutDownResolution: number | null;
    miningEquipmentTypeId: number | null;
    miningEquipmentVendorId: number;
    miningEquipmentOwnerId: number | null;
    miningEquipmentModel: string;
    hsProductId: string;
    capacity: number | null;
    miningEquipmentStatus: string | null;
    qcCompany: string;

    // lists of beans - MVTs
    miningEquipmentNotes: Array<MiningEquipmentNotes>;

    protected constructor(entity?: any) {
        super(entity);

        this.miningEquipmentId = entity?.miningEquipmentId ?? null;
        this.miningEquipmentName = entity?.miningEquipmentName ?? '';
        this.unitId = entity?.unitId ?? null;
        this.startUpDate = entity?.startUpDate ?? null;
        this.startUpResolution = entity?.startUpResolution ?? null;
        this.shutDownDate = entity?.shutDownDate ?? null;
        this.shutDownResolution = entity?.shutDownResolution ?? null;
        this.miningEquipmentTypeId = entity?.miningEquipmentTypeId ?? null;
        this.miningEquipmentVendorId = entity?.miningEquipmentVendorId ?? null;
        this.miningEquipmentOwnerId = entity?.miningEquipmentOwnerId ?? null;
        this.miningEquipmentModel = entity?.miningEquipmentModel ?? '';
        this.hsProductId = entity?.hsProductId ?? '';
        this.capacity = entity?.capacity ?? null;
        this.miningEquipmentStatus = entity?.miningEquipmentStatus ?? null;
        this.qcCompany = entity?.qcCompany ?? '';
 
        this.miningEquipmentNotes = entity?.miningEquipmentNotes ?? [];
    }

}
